import { createContext } from 'react'

import { IContext } from './types'

export default createContext<IContext>({ ref: null })
